import { useTableName } from "./my-ag-grid-react-context";
import { useStoreState } from "../../hooks/ep";

export function useGridBorderRadius() {
  const fullScreen = useStoreState((s) => s.misc.fullScreenModeEnabled);
  const tableName = useTableName();
  return fullScreen && tableName === "churn_risk" ? "0" : "4px";
}
